<template>
<drawer :opened.sync="opened" style="min-width:700px;width:700px;" @close="onCloseBtnClick">
  <template #header>{{model.siteName}} {{model.siteDeviceName}} 异常因子匹配</template>

  <template #body>
    <el-form ref="form" :rules="rules" :model="model" style="height: 100%;">
      <el-table
        ref="table"
        :data="model.errorBackData"
        height="100%"
        border
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table"
        style="width:100%"
      >
        <el-table-column label="序号" width="50" align="center" fixed>
          <template slot-scope="{$index}">{{$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="alias" label="异常因子" align="center" />
        <el-table-column label="匹配因子" align="center" prop="factorId">
          <template slot-scope="scope">
            <el-form-item
              :prop="'errorBackData.' + scope.$index + '.factorId'"
              placeholder="请选择匹配因子"
              :rules="rules.factorId">
              <el-select
                v-model="scope.row.factorId"
                size="small"
                @change="onChangeProgram"
              >
                <el-option
                  v-for="site in siteFactors"
                  :key="site.factorId"
                  :value="site.factorId"
                  :label="site.name"
                  v-if="scope.row.factorId !== site.factorId && selectIdsArr.indexOf(site.factorId) === -1"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="toSave">提交</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseStore from '../../../components/BaseStore'

export default {
  name: 'Editor',
  extends: BaseStore,
  data () {
    return {
      opened: false,
      model: {},
      selectIdsArr: [],
      rules: {
        factorId: [{
          required: true,
          message: '必填字段',
          trigger: 'change'
        }]
      },
      dataList: [],
      siteFactors: []
    }
  },
  methods: {
    open (data) {
      this.$refs.form.clearValidate()
      this.dataList = JSON.parse(JSON.stringify(data.errorBackData)).map(item => {
        return {
          ...item,
          factorId: ''
        }
      })

      this.siteFactors = JSON.parse(JSON.stringify(data.factors)).map(item => {
        return {
          ...item,
          disabled: false
        }
      })

      this.model = data
      this.opened = true
    },
    onChangeProgram () {
      this.selectIdsArr = []

      for (const item of this.model.errorBackData) {
        if (item.factorId) {
          this.selectIdsArr.push(item.factorId)
        }
      }
    },
    setBackData (backData) {
      let {factorMap} = this

      if (backData.isSave) {
        if (backData.isDelete) {
          this.getDataList()
          this.$notify({
            type: 'success',
            position: 'bottom-right',
            message: `删除成功!`
          })
          return
        }
        this.$notify({
          type: 'success',
          position: 'bottom-right',
          message: `导入成功! ${backData.errRatio ? '错误率：' + backData.errRatio + '%(<20%容错率)' : ''}`
        })
      } else if (backData.isSave === false) {
        let factorNames = backData.noSiteDeviceFactorIds.map(item => {
          return factorMap[item].name
        })

        this.$notify({
          type: 'error',
          position: 'bottom-right',
          message: `导入失败! ${backData.errRatio ? '错误率：' + backData.errRatio + '%(>20%容错率)' : ''}
            ${this.model.filterSiteDeviceMap[this.model.siteDeviceId].name}不包含${factorNames.join(',')}因子
          `
        })
      }

      this.close()
    },
    toSave () {
      this.changeLoadStatus(true)
      let {model} = this

      this.$refs['form'].validate(flag => {
        if (!flag) {
          this.changeLoadStatus(false)
          return false
        }

        let querData = {
          beginTime: model.backData.beginTime,
          endTime: model.backData.endTime,
          keyStr: model.backData.keyStr,
          siteId: model.backData.siteId,
          siteDeviceId: model.backData.siteDeviceId,
          factorAliasStandardNames: model.errorBackData
        }

        this.$api.Integral.saveData(querData).then(backData => {
          this.setBackData(backData)
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      })
    },
    onCloseBtnClick () {
      this.close()
    },
    close () {
      this.opened = false
      this.$refs.form.clearValidate()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.time-selector {
  margin: 0;
  padding: 2.857142857142857% 0 0 0;
  user-select: none;
  overflow: hidden;

  &:after {
    content: "";
    display: table;
    clear: both;
  }

  .time-item {
    float: left;
    width: 5.714285714285714%;
    margin-bottom: 2.857142857142857%;
    border: 1px solid #dcdfe6 {
      radius: 5px;
    };
    color: #606266;
    text-align: center;
    cursor: pointer;

    & + .time-item:not(:nth-child(13)) {
      margin-left: 2.857142857142857%
    }

    &:hover {
      border-color: #c6e2ff;
      background-color: #ecf5ff;
      color: #409eff;
    }

    &:active {
      border-color: #3a8ee6;
      color: #3a8ee6;
    }

    &.is-disabled {
      border-color: #ebeef5;
      background-color: #fff;
      color: #c0c4cc;
      cursor: not-allowed;
    }

    &.selecting,
    &.hover {
      border-color: #c2e7b0;
      background-color: #f0f9eb;
      color: #67c23a;
    }

    &.is-selected {
      border-color: #F56C6C;
      background-color: #F56C6C;
      color: #ffffff;
      cursor: not-allowed;
    }

    .time-item-text {
      position: relative;
      display: block;
      padding-bottom: 100%;

      &:before {
        content: attr(text);
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        line-height: 0;
      }
    }
  }
}

.error-times {
  margin: 2.857142857142857% 0;
  line-height: 1.6;
  color: #606266;
  overflow: hidden;

  &:after {
    content: "";
    display: table;
    clear: both;
  }

  > * {
    float: left;
  }

  > .error-time-label {
    padding-right: 10px;
  }

  > .error-time-list {
    margin: 0;
    padding: 0;

    &:empty:before {
      content: "无";
    }

    > .error-time-item {
      > * {
        float: left;
      }

      > .error-time-range {
        width: 100px;
      }

      > .error-time-delete-btn {
        color: #f56c6c;
        cursor: pointer;
        user-select: none;

        &:hover {
          color: #ff0000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/IntegralEditor.vue